import { AllPublicationFolderE } from './publication';
import { BookTypeE } from './book';

export const PROJECT_NAME_MAX_LENGTH = 255;

// A single book/book part/document, or a private user file, attached directly to a project (i.e. not
// through one of its folders). Mirrors the backend's ProjectFileDTO.
export interface ProjectFileI {
    id: number;
    publicationType: AllPublicationFolderE;
    // Absent for USER_FILE entries: id already carries the UserFile's own identity.
    publicationId?: number;
    projectId: number;
    projectName: string;
    creationDate?: string;
    title?: string;
    reference?: string;
    version?: number;
    userStatus?: string;
    bookType?: BookTypeE;
    firstBookPartId?: number;
    bookTitle?: string;
    bookId?: number;
    partner?: string;
    documentTypeCode?: string;
    // Only ever set for USER_FILE entries.
    fileName?: string;
}

export interface ProjectPublicationsDialogDataI {
    projectName: string;
    isFolderOwner: boolean;
    publications: ProjectFileI[];
}

export interface ProjectFolderI {
    id: number;
    name: string;
    createdAt?: string;
    lastUpdateDate?: string;
}

// Lightweight identifier of a book/book part/document attached directly to a project (i.e. not through
// one of its folders) - never a USER_FILE, since those aren't publications callers need to check against.
export interface ProjectFileReferenceI {
    publicationId: number;
    publicationType: AllPublicationFolderE;
}

export interface ProjectI {
    id: number;
    name: string;
    createdAt?: string;
    lastUpdateDate?: string;
    folders: ProjectFolderI[];
    fileReferences?: ProjectFileReferenceI[];
}

export enum ProjectSortFieldE {
    NAME = 'name',
    LAST_UPDATE = 'lastUpdate'
}

export type ProjectSortDirectionT = 'asc' | 'desc';
